import { render, staticRenderFns } from "./DeliveryInfo.vue?vue&type=template&id=0492ac70&scoped=true&"
import script from "./DeliveryInfo.vue?vue&type=script&lang=ts&"
export * from "./DeliveryInfo.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryInfo.vue?vue&type=style&index=0&id=0492ac70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0492ac70",
  null
  
)

export default component.exports